import { debounce } from "client/Misc/utils";
import {
	Dispatch,
	SetStateAction,
	useEffect,
	useMemo,
	useState
} from "react";

export function useDebouncedValue<T>(value: T, delay: number): T | undefined {
	const [debouncedValue, setDebouncedValue] = useState<T>();

	const debouncedSetValue = useMemo(
		(): Dispatch<SetStateAction<T | undefined>> => {
			return debounce(setDebouncedValue, delay);
		},
		[delay]
	);

	useEffect(
		(): void => {
			debouncedSetValue(value);
		},
		[debouncedSetValue, value]
	);

	return debouncedValue;
}